import { useMode } from "@/context/ModeContext";
import type { AudienceType } from "@/types/work";

const options: { value: AudienceType; label: string; icon: string }[] = [
  { value: "male", label: "男性向け", icon: "ri-user-line" },
  { value: "female", label: "女性向け", icon: "ri-user-star-line" },
];

export default function ModeSwitch({ compact = false }: { compact?: boolean }) {
  const { mode, setMode } = useMode();

  return (
    <div className="flex items-center gap-2">
      <div
        role="group"
        aria-label="表示モードの切り替え"
        className={`inline-flex items-center rounded-full border border-background-300 bg-background-100 p-1 ${
          compact ? "w-full" : ""
        }`}
      >
        {options.map((option) => {
          const active = mode === option.value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => setMode(option.value)}
              aria-pressed={active}
              className={`inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full font-medium transition-colors ${
                compact ? "h-11 flex-1 text-[14px]" : "h-9 px-3.5 text-[13px]"
              } ${
                active
                  ? "brand-gradient text-background-50"
                  : "text-foreground-700 hover:bg-background-50 hover:text-foreground-950"
              }`}
            >
              <i className={`${option.icon} text-[14px]`} aria-hidden="true" />
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}